import React from 'react';
import { Plus, Send } from 'lucide-react';

export const NewPostForm = ({ 
  show, 
  setShow, 
  content, 
  setContent, 
  isAnonymous, 
  setIsAnonymous, 
  onSubmit, 
  submitting 
}) => {
  if (!show) {
    return (
      <button
        onClick={() => setShow(true)}
        className="w-full p-4 rounded-xl mb-6 flex items-center justify-center gap-2 transition-all hover:scale-[1.01]"
        style={{ 
          background: '#FAF7F3', 
          border: '1px dashed #EAE4DC',
          color: '#6B6878',
          fontFamily: 'Jost, sans-serif'
        }}
        data-testid="new-post-button"
      >
        <Plus className="w-4 h-4" />
        Share a reflection
      </button>
    );
  }
  
  return (
    <div 
      className="p-5 rounded-xl mb-6"
      style={{ background: 'rgba(201,168,76,0.05)', border: '1px solid rgba(201,168,76,0.15)' }}
      data-testid="new-post-form"
    >
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Share what's on your heart..."
        className="w-full p-4 rounded-lg resize-none focus:outline-none"
        style={{ 
          background: 'rgba(26,26,46,0.06)', 
          color: '#1A1A2E',
          border: '1px solid #F7F1EE',
          fontFamily: 'Jost, sans-serif',
          minHeight: '120px'
        }}
        data-testid="new-post-content"
      />
      
      <div className="flex items-center justify-between mt-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={isAnonymous}
            onChange={(e) => setIsAnonymous(e.target.checked)}
            className="rounded"
            data-testid="new-post-anonymous"
          />
          <span 
            className="text-sm"
            style={{ color: '#4A4A5A', fontFamily: 'Jost, sans-serif' }}
          >
            Share anonymously
          </span>
        </label>
        
        <div className="flex gap-2">
          <button
            onClick={() => {
              setShow(false);
              setContent('');
            }}
            className="px-4 py-2 rounded-full text-sm transition-opacity hover:opacity-70"
            style={{ color: '#6B6878', fontFamily: 'Jost, sans-serif' }}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={submitting || content.length < 10}
            className="px-4 py-2 rounded-full text-sm flex items-center gap-2 transition-all hover:scale-105 disabled:opacity-50"
            style={{ 
              background: '#C9A84C', 
              color: '#FBF9F6',
              fontFamily: 'Jost, sans-serif'
            }}
            data-testid="submit-post"
          >
            <Send className="w-4 h-4" />
            {submitting ? 'Sharing...' : 'Share'}
          </button>
        </div>
      </div>
    </div>
  );
};
